import {
  NumberOperation,
  NUMBER_OPERATION_MINUS,
  NUMBER_OPERATION_MULTIPLY,
  NUMBER_OPERATION_PLUS,
} from 'global/constants';
import { IS_NUMERIC_REGEX } from 'webclient.constants';

export function getOperatorSymbol(operator: NumberOperation) {
  if (operator === NUMBER_OPERATION_MINUS) return '-';
  if (operator === NUMBER_OPERATION_MULTIPLY) return 'x';
  if (operator === NUMBER_OPERATION_PLUS) return '+';
}

export function isOperandValid(value: string) {
  const numberVal = Number(value);
  return IS_NUMERIC_REGEX.test(value) && numberVal > -1 && numberVal < 1000;
}

export function calculateAnswer(
  firstOperand: number,
  secondOperand: number,
  operator: NumberOperation
) {
  if (operator === NUMBER_OPERATION_MINUS) return firstOperand - secondOperand;
  if (operator === NUMBER_OPERATION_MULTIPLY)
    return firstOperand * secondOperand;
  if (operator === NUMBER_OPERATION_PLUS) return firstOperand + secondOperand;
}
